import { Store } from '@webtides/element-js';
import loadScript from '../../../../js/util/load-script';

class ReCaptchaStore extends Store {
    constructor() {
        super();
        this.enabled = !!this.reCaptchaSiteKey;
    }

    properties() {
        return {
            enabled: false,
            isLoaded: false,
            isReady: false,
        };
    }

    get reCaptchaSiteKey() {
        return window.siteConfig().reCaptchaSiteKey || false;
    }

    async loadScript() {
        if (!this.enabled || this.isLoaded) return;
        this.isLoaded = true;
        await loadScript('https://www.google.com/recaptcha/api.js?render=' + this.reCaptchaSiteKey, null, false);
        window.grecaptcha.ready(async () => {
            this.isReady = true;
        });
    }

    async execute() {
        return await window.grecaptcha.execute(this.reCaptchaSiteKey, { action: 'submit' });
    }
}

export const reCaptchaStore = new ReCaptchaStore();
